import {Component, HostListener} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {LayoutService} from '../../core/services/layout.service';
import {AsyncPipe, NgClass, NgIf} from '@angular/common';
import {AppSidebarComponent} from './components/app-sidebar/app-sidebar.component';
import {AppHeaderComponent} from './components/app-header/app-header.component';
import {AppFooterComponent} from './components/app-footer/app-footer.component';

@Component({
  selector: 'app-admin-layout.component',
  imports: [
    RouterOutlet,
    AsyncPipe,
    AppSidebarComponent,
    AppHeaderComponent,
    AppFooterComponent,
    NgClass,
    NgIf
  ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent {
  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth >= 1200) {
      this.layoutService.setMobileOpen(false);
      this.layoutService.setHovered(false);
    }
  }

  constructor(public layoutService: LayoutService) {
  }
}
